<!--
    我的课程-创建上课-班级选择
    功能：选择要上课的班级
    说明：旧版本与3.0版本都使用
-->
<template>
  <div class="myClasses" v-loading="loading">
    <el-tabs v-model="tabs.active" type="card">
      <el-tab-pane v-for="(item, index) in tabs.panes" :key="item.name" :label="item.label" :name="item.name">
        <ul class="my-pane flex fw">
          <li
            v-for="(itm, idx) in item.list"
            :key="itm.id"
            :class="{on: itm.chose}"
            @click="itm.chose = !itm.chose; onClass()"
          >
            <h4>{{itm.name}}</h4>
            <p>班级码：{{itm.number}}</p>
            <p>教师：{{itm.teacher && itm.teacher.name ? itm.teacher.name : '--'}}</p>
            <p>学生数：{{itm.student_count || 0}}</p>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>

    <div class="flex jc">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>

    <el-dialog
      title="创建班级"
      :visible.sync="dialogCreate.show"
      width="415px">

      <el-form ref="form" :model="dialogCreate" label-width="90px">
        <el-form-item label="班级名称：">
          <el-input v-model="dialogCreate.name" placeholder="请输入班级名称"></el-input>
        </el-form-item>
      </el-form>

      <div class="flex jc">
        <el-button @click="dialogCreate.show = false">取消</el-button>
        <el-button type="primary" @click="postNewClass">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/views/MyClass/MyClasses/index.vue